import React from "react";
import ShareColorControl from "./ShareColorControl";
import { Form } from "react-bootstrap";
import { DEFAULT_IMAGE_FRAME, IMAGE_FRAME_STYLES } from "./ShareImageFrame";
import ShareImageFramePreview from "./ShareImageFramePreview";

export default function ShareImageFrameControls({ frame, onChange }) {
  const change = (key,value) => onChange({ ...frame, [key]: value });
  return <>
    <div className="share-editor-control-title">Frame</div>
    <Form.Check type="switch" id="share-editor-frame-enabled" label="Show frame" checked={frame.enabled} onChange={(event) => change("enabled",event.target.checked)} />
    {frame.enabled && <>
      <div className="share-editor-frame-presets" aria-label="Image frame styles">
        {IMAGE_FRAME_STYLES.map((style) => <button type="button" key={style.id} className={frame.style === style.id ? "is-selected" : ""} onClick={() => change("style",style.id)} aria-pressed={frame.style === style.id}>
          <ShareImageFramePreview className="share-editor-frame-swatch" scene={{ width: 1000, height: 640 }} frame={{ ...DEFAULT_IMAGE_FRAME, enabled: true, style: style.id, inset: 8, radius: 8, thickness: 14, opacity: 1 }} />
          <span>{style.name}</span>
        </button>)}
      </div>
      <Form.Label htmlFor="share-editor-frame-color" className="share-editor-label">Color</Form.Label>
      <ShareColorControl id="share-editor-frame-color" className="mb-3" value={frame.color} onChange={(event) => change("color",event.target.value)} />
      {[
        { key: "inset", name: "Inset", min: 0, max: 12, step: 0.1, display: `${frame.inset.toFixed(1)}%` },
        { key: "thickness", name: "Thickness", min: 0.5, max: 10, step: 0.5, display: frame.thickness.toFixed(1) },
        { key: "radius", name: "Roundness", min: 0, max: 12, step: 0.1, display: `${frame.radius.toFixed(1)}%` },
        { key: "opacity", name: "Opacity", min: 0.1, max: 1, step: 0.01, display: `${Math.round(frame.opacity*100)}%` },
        ...(["corners","ornate"].includes(frame.style) ? [{ key: "ornamentSize", name: frame.style === "corners" ? "Corner length" : "Ornament size", min: 0.5, max: 2, step: 0.05, display: `${Math.round(frame.ornamentSize*100)}%` }] : []),
      ].map((control) => <React.Fragment key={control.key}>
        <Form.Label className="share-editor-label">{control.name}<span>{control.display}</span></Form.Label>
        <Form.Range aria-label={`Frame ${control.name.toLowerCase()}`} min={control.min} max={control.max} step={control.step} value={frame[control.key]} onChange={(event) => change(control.key,Number(event.target.value))} />
      </React.Fragment>)}
    </>}
  </>;
}
